import { inject, Injectable } from '@angular/core';
import { APP_UPDATE_ADAPTER } from './update-adapters/update-adapter';

/**
 * Service to handle PWA app updates.
 * - Checks for updates on every navigation
 * - Shows sticky info toast when new version available
 * - Logs version changes to console
 */
@Injectable({ providedIn: 'root' })
export class AppUpdateService {
  private readonly updateAdapter = inject(APP_UPDATE_ADAPTER);
  readonly updateAvailable$ = this.updateAdapter.updateAvailable$;

  initialize(): void {
    this.updateAdapter.initialize();
  }

  checkForUpdate(): Promise<boolean> {
    return this.updateAdapter.checkForUpdate();
  }

  activateUpdate(): Promise<void> {
    return Promise.resolve()
      .then(() => this.updateAdapter.downloadUpdate())
      .then(() => this.updateAdapter.applyUpdate())
      .then(() => this.updateAdapter.restartApp());
  }
}
